import { merge } from 'lodash/fp';
import { createEntityAdapter, EntityState } from '@reduxjs/toolkit';

export function createCustomEntityAdapter<T>(options: {
  selectId: (model: Partial<T>) => string | number;
  sortComparer?: false | ((a: T, b: T) => number);
}) {
  const entityAdapter = createEntityAdapter<T>(options);

  /*
   * Update functions will replace the existing entity by default,
   * this function will only patch it, meaning it will keep the
   * properties of the previous entity, if there are any.
   * */
  function patchOne(state: EntityState<T>, patch: Partial<T>) {
    const entityId = options.selectId(patch);

    const existingEntity = entityAdapter
      .getSelectors()
      .selectById(state, entityId);

    entityAdapter.upsertOne(state, merge(existingEntity, patch));
  }

  return {
    ...entityAdapter,
    patchOne,
  };
}
